"use client";
import { User } from "@/models/user";
import { Box } from "@mui/material";
import _ from "lodash";
import { memo } from "react";
import ReportContent from "./ReportContent";
interface ReportProps {
  slug: string;
  isShare: boolean;
  reportAttachments: any;
  reportId: number;
  dataDetailType: number;
  isPaymentEd?: boolean;
  isOpenProtected?: boolean;
  dataDetail?: any;
  reportAttachmentsOption?: string[];
  lang: string;
  user?: User | null;
  isMobile?: boolean;
}

const Report = (data: ReportProps) => {
  return (
    <Box className="flex justify-center !overflow-visible">
      <div className="report-content w-full lg:w-[1440px] !overflow-visible">
        <ReportContent
          isMobile={data.isMobile}
          lang={data.lang}
          user={data.user}
          reportAttachmentsOption={data.reportAttachmentsOption}
          isOpenProtected={data.isOpenProtected}
          slug={data.slug}
          isShare={data.isShare}
          reportAttachments={data.reportAttachments}
          reportId={data.reportId}
          dataDetailType={data.dataDetailType}
          isPaymentEd={data.isPaymentEd}
          dataDetail={data.dataDetail}
        />
      </div>
    </Box>
  );
};

export default memo(Report, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});
